<template>
  <div>
    <div class="edit">
      <div class="content">
        <div class="container">
          <!-- <form @submit.prevent="sendData"> -->
          <div class="row">
            <el-form ref="form" :model="form" :rules="rules" label-width="170px">
              <div class="col-md-12">
                <h2 class="text-center title">
                  {{ $t('editProfileStudent.editYourInformation') }}
                </h2>
              </div>
              <el-form-item prop="firstname" :label="$t('singup.name')">
                <el-input
                  v-model.trim="form.firstname"
                  :popper-class="'capitalize'"
                  size="small"
                  :placeholder="$t('editProfileTutor.first')"
                  @focus="$event.target.select()"
                >
                </el-input>
              </el-form-item>
              <el-form-item prop="lastname" :label="$t('editProfileTutor.last')">
                <el-input
                  v-model.trim="form.lastname"
                  :popper-class="'capitalize'"
                  size="small"
                  :placeholder="$t('editProfileTutor.last')"
                  @focus="$event.target.select()"
                >
                </el-input>
              </el-form-item>
              <div v-if="$store.state.sectionOfStoreOfTutor.typeOfSignUp === 'student'" class="col-12">
                <el-form-item :label="$t('singup.grade')" prop="grade_id">
                  <el-select
                    id="grade"
                    v-model="grade_id"
                    placeholder="Select"
                    size="small"
                    popper-class="capitalize"
                    class="form-control form-control-lg text-capitalize"
                  >
                    >
                    <el-option v-for="(grade, i) in grades" :key="i" :value="grade.id"
                      >{{ grade.name }}
                      >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div v-if="$store.state.sectionOfStoreOfTutor.typeOfSignUp === 'student'" class="col-6">
                <el-form-item prop="firstname">
                  <el-input
                    v-model="nameOfTheSchool"
                    :popper-class="'capitalize'"
                    size="small"
                    :placeholder="$t('singup.schoolName')"
                    class="form-control form-control-lg text-capitalize"
                  >
                  </el-input>
                </el-form-item>
              </div>
              <div v-if="$store.state.sectionOfStoreOfTutor.typeOfSignUp === 'tutor'">
                <el-form-item prop="email" label="email">
                  <el-input
                    id="email"
                    v-model="email"
                    :popper-class="'capitalize'"
                    size="small"
                    :placeholder="$t('singup.emailEx')"
                    @focus="$event.target.select()"
                  >
                  </el-input>
                </el-form-item>
              </div>
              <el-form-item prop="username" :label="$t('editProfileTutor.newUsername')">
                <el-input
                  id="username"
                  v-model.trim="form.username"
                  size="small"
                  :placeholder="$t('singup.usernameEx')"
                  name="username"
                  type="text"
                  :popper-class="'capitalize'"
                >
                </el-input>
              </el-form-item>

              <el-form-item prop="newPassword" label="Password">
                <el-input
                  id="inlineFormInputGroupUsername"
                  ref="newPassword"
                  v-model="form.newPassword"
                  :popper-class="'capitalize'"
                  size="small"
                  type="password"
                  name="password"
                  show-password
                >
                </el-input>
              </el-form-item>

              <el-form-item prop="verifyPassword" label="Verify password">
                <el-input
                  id="verifyPassword"
                  ref="verifyPassword"
                  v-model="form.verifyPassword"
                  :popper-class="'capitalize'"
                  size="small"
                  type="password"
                  name="verifyPassword"
                  show-password
                >
                </el-input>
              </el-form-item>

              <div class="col-12">
                <br />
              </div>
              <el-form-item class="buttons">
                <el-button class="btn btn-danger" @click="goBack">{{ $t('singup.cancel') }}</el-button>
                <el-button class="btn btn-primary" @click="sendData">{{ $t('singup.submit') }}</el-button>
              </el-form-item>
              <!-- <div class="col-12 buttons">
                <button class="btn btn-danger" @click="goBack">{{ $t('singup.cancel') }}</button>
                <button class="btn btn-primary" @click="sendData">{{ $t('singup.submit') }}</button>
              </div> -->
            </el-form>

            <!-- empieza -->
            <!-- <div class="col-md-12">
                <h2 class="text-center title">
                  {{ $t('editProfileStudent.editYourInformation') }}
                </h2>
              </div>
              <label class="col-12">{{ $t('singup.name') }}</label>
              <div class="col-6">
                <input
                  id="firstname"
                  v-model.trim="firstname"
                  v-validate="'required|alpha_spaces|max:20'"
                  name="name"
                  type="text"
                  class="form-control form-control-lg text-capitalize"
                  :placeholder="$t('editProfileTutor.first')"
                  :disabled="!editable"
                  @focus="$event.target.select()"
                />
                <span v-show="errors.has('name')" class="invalid-field">{{ $t('singup.nameIsRequired') }}</span>
              </div>

              <div class="col-6">
                <input
                  id="lastname"
                  v-model.trim="lastname"
                  v-validate="'required|alpha_spaces|max:20'"
                  name="lastname"
                  type="text"
                  class="form-control form-control-lg text-capitalize"
                  :placeholder="$t('editProfileTutor.last')"
                  :disabled="!editable"
                  @focus="$event.target.select()"
                />
                <span v-show="errors.has('lastname')" class="invalid-field">{{ $t('singup.lastNameRequired') }}</span>
              </div>

              <div v-if="$store.state.sectionOfStoreOfTutor.typeOfSignUp === 'student'" class="col-12">
                <label for="grade">{{ $t('singup.grade') }}</label>
                <select id="grade" v-model="grade_id" class="form-control form-control-lg text-capitalize">
                  <option v-for="(grade, i) in grades" :key="i" :value="grade.id">{{ grade.name }}</option>
                </select>
              </div>

              <div v-if="$store.state.sectionOfStoreOfTutor.typeOfSignUp === 'student'" class="col-6">
                <label>{{ $t('singup.schoolName') }}</label>
                <input
                  id="nameOfTheSchool"
                  v-model="nameOfTheSchool"
                  v-validate="'required|max:30'"
                  name="nameOfTheSchool"
                  type="text"
                  class="form-control form-control-lg text-capitalize"
                  placeholder
                />
                <span v-show="errors.has('nameOfTheSchool')" class="invalid-field">{{
                  $t('singup.schoolNameRequired')
                }}</span>
              </div>

              <div v-if="$store.state.sectionOfStoreOfTutor.typeOfSignUp === 'tutor'" class="col-6">
                <label>{{ $t('singup.email') }}</label>
                <input
                  id="age"
                  v-model="email"
                  v-validate="'required|email|max:30'"
                  name="email"
                  type="text"
                  class="form-control form-control-lg"
                  :placeholder="$t('singup.emailEx')"
                  :disabled="!editable"
                  @focus="$event.target.select()"
                />
                <span v-show="errors.has('email')" class="invalid-field">{{ $t('singup.emailRequired') }}</span>
              </div>

              <div class="col-6">
                <label for="username">{{ $t('editProfileTutor.newUsername') }}</label>
                <input
                  id="username"
                  v-model.trim="username"
                  v-validate="'required|max:12'"
                  name="username"
                  type="text"
                  class="form-control form-control-lg"
                  :placeholder="$t('singup.usernameEx')"
                  disabled
                />
                <span v-show="errors.has('username')" class="invalid-field">{{ $t('singup.usernameRequired') }}</span>
              </div>

              <transition name="fade">
                <div v-if="showPassword" class="col-6">
                  <label for="newPassword">{{ $t('editProfileStudent.newPassword') }}</label>
                  <div class="input-group">
                    <input
                      id="inlineFormInputGroupUsername"
                      ref="password"
                      v-model="newPassword"
                      v-validate="'required|max:12'"
                      type="password"
                      name="password"
                      class="form-control"
                      :disabled="!editable"
                    />
                    <div class="input-group-prepend" @click="togglePassword('password')">
                      <div class="input-group-text">
                        <i class="fa fa-eye"></i>
                      </div>
                    </div>
                  </div>
                  <span v-show="errors.has('newPassword')" class="invalid-field">{{
                    $t('singup.verifyNewPassword')
                  }}</span>
                  <br />
                </div>
              </transition>

              <transition name="fade">
                <div v-if="showPassword" class="col-6">
                  <label for="verifyPassword">{{ $t('singup.verifyYourPassword') }}</label>
                  <div class="input-group">
                    <input
                      id="verifyPassword"
                      ref="verifyPassword"
                      v-model="verifyPassword"
                      v-validate="'required|confirmed:password|max:12'"
                      type="password"
                      name="verifyPassword"
                      class="form-control"
                      :disabled="!editable"
                    />
                    <div class="input-group-prepend" @click="togglePassword('verifyPassword')">
                      <div class="input-group-text">
                        <i class="fa fa-eye"></i>
                      </div>
                    </div>
                  </div>
                  <span v-show="errors.has('verifyPassword')" class="invalid-field">{{
                    $t('singup.verifyYourPasswordMaxSeven')
                  }}</span>
                </div>
              </transition>

              <div class="col-12">
                <br />
              </div>
              <div class="col-12 buttons">
                <input :value="$t('singup.cancel')" class="btn btn-danger" @click="goBack" />
                <input
                  type="submit"
                  :value="$t('singup.submit')"
                  class="btn btn-primary"
                  :disabled="!(editable || pwEditable)"
                />
              </div>
              <i v-if="!editable" class="fa fa-pencil edit-profile" @click="toggleEditing"></i>
              <i v-if="editable" class="fa fa-close cancel-edit" @click="toggleEditing"></i>
            </div>  -->
            <!-- TERMINA -->
            <!-- </form> -->
          </div>
        </div>
      </div>
      <!-- into password of tutor start -->
      <tpm-modal :showhide="showIntoPassword">
        <!-- <div class="modal-header">

          <h5 class="modal-title text-white">{{ $t('editProfileTutor.intoYourPassword') }}</h5>

          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="showIntoPassword = false">
            <img src="@/assets/ic_close_white_24dp_1x.png" class alt="Close" />
          </button>
        </div>
        <div class="modal-body"> -->
        <!-- content start -->
        <!-- <div class="row modal-body-custom">
            <div class="col-md-12">
              <div class="form-group">
                <label for="password">
                  <strong>{{ $t('editProfileTutor.yourPassword') }}</strong>
                </label>
                <input
                  id="pwd"
                  v-model="password"
                  type="password"
                  class="form-control form-control-lg"
                  placeholder="password"
                  @keyup.enter="sendData"
                />
              </div>
              <router-link to="/tutor/children">
                <button class="btn btn-primary submit" :disabled="password === ''" @click="sendData">
                  {{ $t('singup.submit') }}
                </button>
              </router-link>
            </div>
          </div> -->
        <!-- #content end -->
        <!-- </div> -->
      </tpm-modal>
      <!-- #into password of tutor end -->
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert';
import { mapGetters } from 'vuex';
//import axios from 'axios';

export default {
  name: 'ProfileEdit',
  data() {
    var validatePass = (rule, value, callback) => {
      if (value !== '' && this.form.verifyPassword !== '') {
        console.log('verificando passwword');
        this.$refs['form'].validateField('verifyPassword');
      }
      callback();
      // }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };
    return {
      form: {
        firstname: '',
        lastname: '',
        username: '',
        newPassword: '',
        verifyPassword: '',
      },
      showPassword: false,
      infoPassword: this.$t('messages.changePassword'),
      //firstname: '',
      //lastname: '',
      grade_id: '',
      nameOfTheSchool: '',
      email: '',
      //username: '',
      password: '',
      // newPassword: '',
      // verifyPassword: '',
      // Muestra el modal donde el usuario introduce su contrasea.
      showIntoPassword: false,
      editable: false,
      pwEditable: false,
      rules: {
        firstname: [{ required: true, message: 'Name can not be empty', trigger: 'blur' }],
        lastname: [{ required: true, message: 'Last name can not be empty', trigger: 'blur' }],
        username: [{ required: true, message: 'Username can not be empty', trigger: 'blur' }],
        newPassword: [{ validator: validatePass, trigger: 'blur' }],
        verifyPassword: [{ validator: validatePass2, trigger: 'blur' }],
      },
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/authenticatedUser',
    }),
  },
  created() {
    // this.initWebsockets()
    this.initValuesOfTutor();
    /* se cambia el tamaño del ancho de modal, donde contiene el reporte por estudiante seleccionado */
    var payload = {
      width: '500',
      prefixWidth: 'px',
      height: '',
      prefixHeight: '',
    };
    this.$store.commit('SET_STYLE_MODAL', payload);
  },
  methods: {
    toggleEditing() {
      this.editable = !this.editable;
    },
    goBack() {
      var self = this;
      self.$router.push({ path: '/students' });
    },
    /** Toggle the visibilty of the password. */
    togglePassword(item) {
      this.type = this.type === 'password' ? 'text' : 'password';
      this.$refs[item].setAttribute('type', this.type);
      this.$refs[item].focus();
    },
    togglePasswordAlert() {
      this.pwEditable = !this.pwEditable;
      console.log(this.pwEditable);
      this.showPassword = !this.showPassword;
      if (this.showPassword) {
        this.infoPassword = this.$t('messages.doNotChangePass');
      }
      if (!this.showPassword) {
        this.newPassword = '';
        this.verifyPassword = '';
        this.infoPassword = this.$t('messages.changePassword');
      }
    },
    // Envía el usuario modificado al servidor
    sendData() {
      // if (this.password !== '') {

      this.$refs['form'].validate(valid => {
        console.log('validacion ' + valid);
        if (valid) {
          var user = {};
          user.id = this.user.id;
          user.firstname = this.form.firstname;
          user.lastname = this.form.lastname;
          user.username = this.form.username;
          user.password = this.form.newPassword;
          user.relationship = this.relationshipSelected;
          user.email = this.email;
          if (this.form.newPassword === this.form.verifyPassword) {
            user.new_password = this.form.newPassword;
          }
          user.name_of_the_school = 'NA';
          user.rol_id = 2;
          user.token = this.$store.state.cookie;

          this.showIntoPassword = false;
          this.$httpMain
            .post(`edit-user`, user)
            .then(() => {
              swal({
                title: this.$t('messages.succes'),
                // text: this.$t('messages.yourFile'),
                icon: 'success',
              });
              this.$store.commit('auth/UPDATE_AUTHENTICATED_USER', {
                firstName: this.form.firstname,
                lastName: this.form.lastname,
                username: this.form.username,
                email: this.email,
              });
              this.$router.push({ path: '/students' });
            })
            .catch(() => {
              swal({
                title: 'FATAL ERROR',
                icon: 'error',
              });
            });
        }
        if (!valid) {
          console.log('Esto no fue valido');
        }
      });
      // }
    },
    /** Obtiene los datos del tutor del componente padre "Main" */
    initValuesOfTutor() {
      //this.firstname = this.$store.state.userAuthenticated.firstname;
      this.form.firstname = this.user.firstname;
      this.form.lastname = this.user.lastname;
      this.email = this.user.email;
      this.form.username = this.user.username;
      this.password = '';
      this.relationshipSelected = this.$store.state.userAuthenticated.relationship;
      // Establece el rol de tutor en el componente padre para poder usar ciertas funcionalidades como mostrar unformaci'on que le pertenece al tutor y no al estudiante.
      this.$store.state.sectionOfStoreOfTutor.typeOfSignUp = 'tutor';
    },
  },
};
</script>
<style lang="scss" scoped>
/*
   TOC:
  =======

  1. Primary Styles

  2. Custom Utility Classes

  3. Custom Styles

===================================================== */

/* --------------------------------- */
/* 1. Primary Styles
 ----------------------------------- */
label {
  margin-bottom: 0;
  margin-top: 1rem;
}
/* --------------------------------- */
/* 2. Custom Utility Classes
 ----------------------------------- */
.row {
  position: relative;
}
.edit-profile {
  position: absolute;
  top: 0;
  right: 0;
  width: 30px;
  height: 30px;
  padding: 4px 7px;
  color: #fff;
  font-size: 20px;
  background-color: green;
  border-radius: 5px;
  cursor: pointer;
}
.cancel-edit {
  position: absolute;
  top: 0;
  right: 0;
  width: 30px;
  height: 30px;
  padding: 4px 7px;
  color: #fff;
  font-size: 20px;
  background-color: red;
  border-radius: 5px;
  //cursor: pointer;
}
.edit {
  margin-top: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.5rem;
}
.content {
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.5);
  max-width: 650px;
  border-radius: 10px;
  padding: 1.8rem 1.2rem;
  background-color: #fff;
}
.submit {
  margin-top: 1.5rem;
  float: right;
}
.title {
  margin-bottom: 2rem;
}
.password-info {
  color: #199df5;
  margin-top: 0.5rem;
}
/* --------------------------------- */
/* 15. Custom Styles
----------------------------------- */
/*customizing boostrap*/
.btn-primary {
  color: white;
  background-color: #199df5;
  border-color: #199df5;
  border-radius: 10px;
  width: 150px;
  &:disabled {
    background-color: #999;
    border: 1px solid #999;
  }
}
.btn-danger {
  color: white;
  background-color: #f51919;
  border-color: #f51919;
  border-radius: 10px;
  width: 150px;
  &:disabled {
    background-color: #999;
    border: 1px solid #999;
  }
}
.close {
  position: absolute;
  right: 5px;
  top: 5px;
  background-color: #ff1800 !important;
  opacity: 1 !important;
  border-radius: 50%;
  padding: 6px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-content {
  border-radius: 10px !important;
}
.modal-header {
  background-color: #199df5;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 10px 15px !important;
}
.modal-body-custom {
  padding: 1.5rem 3rem;
}
.alert {
  cursor: pointer;
}
/* Transitions Vuejs */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.invalid-field {
  color: #d50000;
  font-size: 12px;
  position: absolute;
}
.buttons {
  input {
    border-radius: 10px;
    width: 150px;
  }
  input:last-of-type {
    float: right;
  }
}
@media (max-width: 576px) {
  el-form-item {
    .buttons {
      display: flex;
    }
  }
  .btn-primary {
    margin: auto;
    margin-top: 10px;
  }
}
</style>
